import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import {MatDialog} from '@angular/material/dialog';
import {FailedActionDialogComponent} from '../../dialogs/failed-action-dialog/failed-action-dialog.component';
import {FailedMultipleActionsDialogComponent} from '../../dialogs/failed-multiple-actions-dialog/failed-multiple-actions-dialog.component';
import {SessionService} from 'ac-infra';

@Injectable()
export class HttpErrorInterceptorService implements HttpInterceptor {

  private urlsToIgnore = [
    'configuration/security/ldap/test',
    'configuration/security/radius/test',
    'login'
  ];

  constructor(public dialog: MatDialog,
              private sessionService: SessionService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(
        tap((evt) => {
          const errors = this.getMultipleErrors(evt);

          if (errors) {
            if (Array.isArray(errors)) {
              const errorResponseArray = errors.filter(item => item.status >= 400);

              if (errorResponseArray.length > 0) {
                this.dialog.open(FailedMultipleActionsDialogComponent, {
                  width: '560px',
                  data: {
                    message: errors
                  }
                });
              }
            }
          }
        }),
        catchError((error: HttpErrorResponse) => {
          let errorMessage = '';
          if (error.error instanceof ErrorEvent) {
            // client-side error
            errorMessage = `Error: ${error.error.message}`;
          } else {
            // server-side error
            errorMessage = error.error.description;
          }
          const defaultError = error.message ? error.message : 'An error occurred while we were trying to handle your request';
          console.log(error);
          if (request.method !== 'GET' && !this.ignoreUrl(error.url)) {
            this.dialog.open(FailedActionDialogComponent, {
              width: '460px',
              data: {
                responseMessage: errorMessage,
                defaultMessage: defaultError
              }
            });
          }

          if (!error.url.endsWith('/login') && error.status === 401) {
            this.sessionService.endSession();
          }
          return throwError(error);
        })
      );
  }

  private ignoreUrl(requestUrl): boolean {
    return !!this.urlsToIgnore.find(url => {
      return requestUrl.endsWith(url);
    });
  }

  private getMultipleErrors(evt): any {
    return evt.status === 200 && evt.body && Array.isArray(evt.body.multiStatusJsonList)
      ? evt.body.multiStatusJsonList : null;
  }
}
